import Component from "./Component.js"

export default class Live extends Component {

  constructor(props, context) {
    super(props, context)
    this.state.isLive = true
  }

  static get contextTypes() {
    return super.contextTypes
  }
  
  onislive(event) {
    this.setState({isLive: event.detail})
  }

  liveClickHandler() {
    if (!this.state.isLive)
      this.player.goLive()
  }

  render() {
    return <span ref="element" className="amp-live-label" onClick={this.liveClickHandler.bind(this)}>{this.getLocalizedString(this.state.isLive ? "MSG_LIVE" : "MSG_GO_LIVE")}</span>
  }

}
